import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import Cybersecurity from './Cybersecurity';

export default function Blog() {
  return (
    <>
        <Navbar />
        <Cybersecurity />
        <Footer />
        <Copyright />
    </>
  )
}